(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopViewport = window.matchMedia('(min-width: 750px)');

  const setupProductSlider = (track) => {
    if (track.dataset.melReady === 'true') return;
    track.dataset.melReady = 'true';
    const section = track.closest('section');
    const controls = section ? section.querySelectorAll('[data-mel-home-slide]') : [];
    if (!controls.length) return;

    const update = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      controls.forEach((button) => {
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft >= maxScroll;
        const disabled = button.dataset.melHomeSlide === 'previous' ? atStart : atEnd;
        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
      });
    };

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.melHomeSlide === 'previous' ? -1 : 1;
        const card = track.querySelector('.mel-home-card');
        const amount = card ? card.getBoundingClientRect().width + 22 : track.clientWidth * 0.82;
        track.scrollBy({ left: direction * amount, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const setupLoopSlider = (section) => {
    if (section.dataset.melReady === 'true') return;
    const viewport = section.querySelector('[data-mel-loop-viewport]');
    const track = section.querySelector('[data-mel-loop-track]');
    const original = section.querySelector('[data-mel-loop-group]');
    const controls = section.querySelectorAll('[data-mel-loop-slide]');
    if (!viewport || !track || !original) return;
    section.dataset.melReady = 'true';

    const prepareClone = (clone) => {
      clone.removeAttribute('data-mel-loop-group');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, [tabindex]').forEach((item) => item.setAttribute('tabindex', '-1'));
      return clone;
    };

    const before = prepareClone(original.cloneNode(true));
    const after = prepareClone(original.cloneNode(true));
    track.prepend(before);
    track.append(after);

    let scrollTimer;
    let autoplayTimer;
    let userActive = false;

    const sizeMaterialSlides = () => {
      if (!section.classList.contains('mel-home-lab')) return;
      const visibleCount = window.innerWidth < 750 ? 2 : window.innerWidth < 1100 ? 6 : 7;
      const gap = Number.parseFloat(window.getComputedStyle(original).columnGap) || 0;
      const availableWidth = viewport.clientWidth - gap * (visibleCount - 1);
      const width = Math.max(1, availableWidth / visibleCount);
      section.style.setProperty('--mel-home-material-slide-width', `${width}px`);
    };

    const groupWidth = () => original.getBoundingClientRect().width;
    const placeAtOriginal = () => {
      const width = groupWidth();
      if (width > 0) viewport.scrollLeft = width;
    };

    const normalize = () => {
      const width = groupWidth();
      if (!width) return;
      if (viewport.scrollLeft < width * 0.5) viewport.scrollLeft += width;
      if (viewport.scrollLeft > width * 1.5) viewport.scrollLeft -= width;
    };

    const stepSize = () => {
      const cards = original.children;
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      if (cards.length) return cards[0].getBoundingClientRect().width;
      return viewport.clientWidth * 0.8;
    };

    const move = (direction) => {
      viewport.scrollBy({
        left: direction * stepSize(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        userActive = true;
        move(button.dataset.melLoopSlide === 'previous' ? -1 : 1);
      });
    });

    viewport.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      userActive = true;
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });

    viewport.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(normalize, 120);
    }, { passive: true });

    ['pointerdown', 'focusin', 'mouseenter', 'touchstart'].forEach((eventName) => {
      section.addEventListener(eventName, () => {
        userActive = true;
      }, { passive: true });
    });

    const configureAutoplay = () => {
      window.clearInterval(autoplayTimer);
      if (section.dataset.melLoopAutoplay !== 'desktop') return;
      if (!desktopViewport.matches || reducedMotion.matches) return;
      autoplayTimer = window.setInterval(() => {
        if (!userActive && !document.hidden) move(1);
      }, 3600);
    };

    window.addEventListener('resize', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        sizeMaterialSlides();
        placeAtOriginal();
        configureAutoplay();
      }, 150);
    }, { passive: true });

    sizeMaterialSlides();
    requestAnimationFrame(placeAtOriginal);
    configureAutoplay();
  };

  const init = () => {
    document.querySelectorAll('[data-mel-home-slider]').forEach(setupProductSlider);
    document.querySelectorAll('[data-mel-loop-section]').forEach(setupLoopSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
